import React from "react";

import DashBoardImage from "../../assets/image/inner-page/png/telecommute.png";
import YellowShape from "../../assets/image/inner-page/png/yellow-shape.png";
import GreenShape from "../../assets/image/inner-page/png/blue-shape.png";

const Hero = ({ className, ...rest }) => {
  return (
    <div className={className} {...rest}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-7 col-md-9">
            <div
              className="text-center mb-11 mb-lg-24"
              data-aos="zoom-in"
              data-aos-delay={500}
            >
              <h1 className="font-size-11 mb-7">Teletrabajo</h1>
              <p className="font-size-7 px-lg-5 mb-0">
                ¡El teletrabajo es una realidad y ha llegado para quedarse!
              </p>
            </div>
          </div>
        </div>
        {/* Hero Image Group */}
        <div className="row justify-content-center">
          <div className="col-md-10 col-xs-11">
            <div className="l3-hero-image-group w-100">
              {/* Image One */}
              <div
                className="img-1 shadow-13"
                data-aos="fade-up"
                data-aos-delay={500}
                data-aos-once="true"
              >
                <img src={DashBoardImage} alt="" />
                {/* Image Two */}
                <div className="img-2">
                  <img
                    src={YellowShape}
                    alt=""
                    data-aos="fade-right"
                    data-aos-delay={700}
                    data-aos-once="true"
                  />
                </div>
                {/* Image Three */}
                <div className="img-3">
                  <img
                    src={GreenShape}
                    alt=""
                    data-aos="fade-left"
                    data-aos-delay={900}
                    data-aos-once="true"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Hero Image Group */}
      </div>
    </div>
  );
};

export default Hero;
